"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelField = exports.ModelMutator = void 0;
const core_api_1 = require("@ikegps/core-api");
class ModelMutator {
    constructor(field) {
        this.field = field;
    }
    get state() {
        return this.field.collection.state;
    }
    /** Removes the field value. */
    clear() {
        this.state.setFieldValue(this.field.id, null);
    }
    /** Copies from the target into this Collection. */
    copy(from) {
        let stateValue = from.stateValue;
        if (stateValue != null) {
            stateValue = JSON.parse(JSON.stringify(stateValue));
        }
        this.state.setFieldValue(this.field.id, stateValue !== null && stateValue !== void 0 ? stateValue : null);
        return true;
    }
    truncatedCopy(from) {
        return true;
    }
}
exports.ModelMutator = ModelMutator;
class CollectionModelField {
    get distanceUnit() {
        return this._distanceUnit;
    }
    set distanceUnit(value) {
        this._distanceUnit = value;
    }
    get value() {
        return this._value;
    }
    /**
     * Fields are stored in a hash map, they need to be unique.
     * Using the subformInstanceId and the field's schema id creates a unique reference.
     */
    static getStateId(parent, schemaId) {
        return parent.instanceId + ':' + schemaId;
    }
    constructor(parent, schema) {
        this._distanceUnit = core_api_1.IkeUnitDistance.FEET;
        this.parent = parent;
        this.schema = schema;
        this.id = CollectionModelField.getStateId(this.parent, this.schema.id);
    }
    /** Traverse up the tree to find the root collection for this field */
    get collection() {
        return this.parent.collection;
    }
    /** Raw state value that is stored for this field */
    get stateValue() {
        return this.collection.state.getFieldValue(this.id);
    }
    get displayValue() {
        return String(this.stateValue);
    }
    get annotationLabel() {
        return this.parent.title;
    }
    findAncestorField(node, fieldId) {
        if (node.hasField(fieldId)) {
            return node.getField(fieldId);
        }
        if (!node.parent || !node.parent.parent) {
            return undefined;
        }
        return this.findAncestorField(node.parent.parent, fieldId);
    }
}
exports.CollectionModelField = CollectionModelField;
//# sourceMappingURL=collection.field.js.map